import { Flex } from 'theme-ui'
import React, { ReactElement } from 'react'

export default function LastQuery({
  timeSinceLastQuery,
}: {
  timeSinceLastQuery: string
}): ReactElement {
  return (
    <Flex
      sx={{
        mt: '1.6rem',
        px: '1.4rem',
        py: '0.8rem',
        backgroundColor: timeSinceLastQuery ? 'greenApple15' : 'banana50',
        borderRadius: '1rem',
        color: timeSinceLastQuery ? 'greenApple' : 'white',
      }}
    >
      Last query: {timeSinceLastQuery ? timeSinceLastQuery : 'Never'}
    </Flex>
  )
}
